import { Injectable } from '@angular/core';

import { PaymentsAuthenticationService } from '@payments/common-utils';

import { UrlConstants } from '../config/urlConstants';

@Injectable({
    providedIn: 'root',
})
export class QdAuthenticationService extends PaymentsAuthenticationService {
    override authenticateUser(sessionInfo: any) {
        return super.authenticateUser(sessionInfo, UrlConstants.AUTHENTICATE_URI);
    }
}
